import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { LoginCustomization } from '@core/interfaces';
import { FuseConfigService } from '@fuse/services/config.service';
import { LoginCustomizationService } from 'app/main/settings/accounts/preferences/services/login-customization.service';
import { sentry } from 'sentry';

@Injectable({
  providedIn: 'root'
})
export class LoginResolver implements Resolve<any> {
  public loginCustomization: LoginCustomization;

  constructor(
    private readonly loginCustomizationService: LoginCustomizationService,
    private readonly fuseConfigService: FuseConfigService
  ) {
    this.loginCustomization = null;
  }

  async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<LoginCustomization> {
    try {
      this.hideToolbarAndNavbar();
      this.loginCustomization = await this.loginCustomizationService.loginCustomizationBySlug();
      return this.loginCustomization;
    } catch (err) {
      sentry.captureException(err);
      return null;
    }
  }

  public hideToolbarAndNavbar(): void {
    this.fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true },
        sidepanel: { hidden: true }
      }
    };
  }
}
